import { createContext, useContext } from 'react';
import type { AvatarGroupContextValue } from './Avatar.types';

export const AvatarGroupContext = createContext<AvatarGroupContextValue | null>(null);

export const useAvatarGroupContext = () => useContext(AvatarGroupContext);
